import followSagas from './followSagas';
import fetchFolloweesSagas from './fetchFolloweesSagas';

export default [...followSagas, ...fetchFolloweesSagas];
